import { Text, Stack, Divider } from "@mantine/core"
import { ColumnLayout } from "@/routes/app/-components/column-layout"
import { useTranslation } from "react-i18next"
import { getFormattedCurrency } from "@/utils/get-formatted-number"
import { getFormattedDate } from "@/utils/get-formatted-date"
import { PersonName } from "@components/PersonName"
import { ResourceObjectMonetaryValue } from "../types"
import { DetailsCard } from "@/routes/app/-components/details-card"
import { LabeledValue } from "@components/default-list/labeled-value"
import { AddResourceObjectActionIcon } from "./resource-object-action-icons"

interface ValuationTabProps {
  monetaryValues: ResourceObjectMonetaryValue[]
  onCreateValuation?: () => void
}

export function ValuationTab({
  monetaryValues,
  onCreateValuation,
}: ValuationTabProps) {
  const { t } = useTranslation("app_server")

  return (
    <ColumnLayout>
      <DetailsCard
        title={t("ValueHistory")}
        buttons={
          onCreateValuation ? (
            <AddResourceObjectActionIcon onClick={onCreateValuation} />
          ) : undefined
        }
      >
        {monetaryValues.length > 0 ? (
          monetaryValues.map((value, i) => {
            const hasValues =
              value.monetaryValue !== undefined ||
              value.valuation ||
              value.estimateDate
            return hasValues ? (
              <Stack
                key={i}
                style={{
                  marginBottom: i < monetaryValues.length - 1 ? "1rem" : 0,
                }}
              >
                {value.monetaryValue !== undefined && (
                  <LabeledValue
                    label={t("Price")}
                    value={getFormattedCurrency(value.monetaryValue)}
                  />
                )}
                {value.valuation && (
                  <LabeledValue
                    label={t("Valuation")}
                    value={getFormattedCurrency(value.valuation)}
                  />
                )}
                {value.estimateDate && (
                  <LabeledValue
                    label={t("EstimateDate")}
                    value={getFormattedDate(value.estimateDate)}
                  />
                )}
                {value.estimatedByPersonId && (
                  <LabeledValue
                    label={t("EstimatedBy")}
                    value={<PersonName personId={value.estimatedByPersonId} />}
                  />
                )}
                <Divider />
              </Stack>
            ) : null
          })
        ) : (
          <Text color="dimmed">{t("NoData")}</Text>
        )}
      </DetailsCard>
    </ColumnLayout>
  )
}
